import { getLocale } from "../misc";
export const GET_DEFECT_LOCALE = value => {
    const toEn = {
      //Order-Type
      'Appareils': ['Devices only'],
       'Nouvelle commande de services sans fil': ['New Wireless Activation'],
       'Renouvellement': ['Renewal'],
       'Accessoires': ['Accessories Only'],
       'Ajout à un compte existant': ['Add-on Activation'],
    };
    const toFr = {
      //Order-Type
      'Devices only': ['Appareils'],
      'New Wireless Activation': ['Nouvelle commande de services sans fil'],
      'Renewal': ['Renouvellement'],
      'Accessories Only': ['Accessoires'],
      'Add-on Activation': ['Ajout à un compte existant'],
    };
    const locale = getLocale();
    const listToCheck = locale === 'fr-CA' ? toFr : toEn;
    return listToCheck[value] || value;
  };